import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  { title: "Palvelu", links: [
    ["Tietoa sisällöntuottajille", "/tietoa-sisallontuottajille"],
    ["Tietoa yrityksille", "/tietoa-yrityksille"],
    ["Hinnoittelu", "/hinnoittelu"],
    ["Usein kysytyt kysymykset", "/ukk"],
  ] },
  { title: "Lakiasiat", links: [
    ["Käyttöehdot", "/kayttoehdot"],
    ["Tietosuojaseloste", "/tietosuoja"],
    ["Evästekäytäntö", "/evasteet"],
  ] },
  { title: "Yhteys", links: [
    ["Ota yhteyttä", "/ota-yhteytta"],
  ] },
];

export default function PublicFooter() {
  return (
    <footer className="bg-white border-t border-[#E6E1D9]" data-testid="public-footer">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center"><Logo variant="light" className="h-6 w-auto" /></Link>
            <p className="mt-2 text-[13px] text-[#6E675C] leading-relaxed">Sisällöntuottajien ja yritysten alusta.</p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <div className="text-[13px] font-semibold text-[#292827]">{col.title}</div>
              <ul className="mt-3 space-y-2">
                {col.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} data-testid={`footer-link-${to.slice(1)}`}
                      className="text-[13px] text-[#3A3733] hover:text-[#292827] transition-colors">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-[#E6E1D9] text-[13px] text-[#6E675C]">
          © 2026 Creatori
        </div>
      </div>
    </footer>
  );
}
